import type { z } from 'zod';
import { SchemaTimestamp } from '@axiom/types';

import { TagSchema } from './tag';
import { CandidateTagSubtagSchema } from './candidate-tag-subtag';

export const CandidateTagSchema = TagSchema.extend({
  createdAt: SchemaTimestamp.nullable(),
  updatedAt: SchemaTimestamp.nullable(),
  CandidateTag: CandidateTagSubtagSchema,
});

export type CandidateTag = z.infer<typeof CandidateTagSchema>;
